import { useMemo } from "react";
import { useLocationLps, useOpenOrders, useSkuNames } from "@/lib/api/map3d";
import { qty } from "@/lib/format";
import { statusLabel } from "@/lib/labels";
import { ordersByLp } from "@/modules/map3d/model";

/**
 * Katakdagi palletlar (LP) — 2D xarita kartasida: pallet kodi, holati,
 * KIMNING buyurtmasi va tarkibi. 3D xarita bilan bir xil manba
 * (inventory LP + picking buyurtmalari).
 */
export function CellPallets({ locationId }: { locationId: string }) {
  const lps = useLocationLps(locationId);
  const orders = useOpenOrders();
  const byLp = useMemo(() => ordersByLp(orders.data?.items ?? []), [orders.data]);
  const items = lps.data?.items ?? [];
  const names = useSkuNames(items.flatMap((lp) => lp.contents.map((content) => content.sku_id)));

  if (lps.isLoading) return <div className="skeleton" style={{ height: 48 }} />;
  if (items.length === 0) {
    return (
      <p className="field-hint" style={{ margin: 0 }}>
        Bu katakda LP yo'q.
      </p>
    );
  }
  return (
    <table className="data" style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>LP</th>
          <th>Holati</th>
          <th>Buyurtma</th>
          <th>Tarkib</th>
        </tr>
      </thead>
      <tbody>
        {items.map((lp) => {
          const order = byLp.get(lp.id);
          return (
            <tr key={lp.id}>
              <td className="mono">{lp.lp_code}</td>
              <td>{statusLabel(lp.status)}</td>
              <td>
                {order ? (
                  <>
                    <span className="mono">{order.order_number}</span>
                    <div className="field-hint">
                      {order.customer_name ?? "mijoz noma'lum"} · {statusLabel(order.status)}
                    </div>
                  </>
                ) : (
                  "—"
                )}
              </td>
              <td>
                {lp.contents.map((content) => {
                  const sku = names.get(content.sku_id);
                  return (
                    <div key={`${content.sku_id}-${content.lot_ref ?? ""}`}>
                      <span className="mono">{sku?.article ?? content.sku_id.slice(0, 8)}</span>{" "}
                      {sku?.name ?? ""} — <b>{qty(content.qty)}</b>
                    </div>
                  );
                })}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
